import React, { useEffect } from 'react';
import styled from 'styled-components/native';
import { AppScreen } from '@/components/compose/app.screen';
import { useAppRouter } from '@/hooks/use.app.router';
import { AppImageView } from '@/components/base/app.image.view';
import { useAssets } from '@/hooks/use.assets';
import { Box } from '@/components/base/box';
import { AppTextView } from '@/components/base/app.text.view';
import { AppButton } from '@/components/base/app.button';
import { ScreenNamesEnum } from '@/constants';
import { useNavigation } from '@react-navigation/native';

export default function PaymentDoneScreen() {
  const assets = useAssets();
  const router = useAppRouter();
  const navigation = useNavigation();
  const {
    params: { doctorId, redirectUrl },
  } = useAppRouter();

  useEffect(() => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [redirectUrl]);

  return (
    <AppScreen connectionStatus={false}>
      <Box flexGrow={1} alignItems={'center'} justifyContent={'center'}>
        <LogoImage source={assets.images.logo} />
      </Box>
      <MessageBox>
        {redirectUrl ? (
          <>
            <SuccessText text={'در حال انتقال به درگاه پرداخت...'} variant={'title'} textColor={'jade'} bold />
          </>
        ) : (
          <>
            <SuccessText text={'پرداخت با موفقیت انجام شد'} variant={'title'} textColor={'jade'} bold />
            <SuccessText text={'ویزیت آرام و راحتی رو براتون آرزو میکنیم :)'} variant={'primary'} textColor={'jade_dark'} bold />

            <BackButton
              title={'بازگشت به اپلیکیشن'}
              onPress={() => {
                if (doctorId) {
                  navigation.reset({
                    index: 1,
                    routes: [{ name: ScreenNamesEnum.MainScreen } as any, { name: ScreenNamesEnum.DoctorProfile, params: { id: doctorId } } as any],
                  });
                } else {
                  router.goBack();
                }
              }}
            />
          </>
        )}
      </MessageBox>
    </AppScreen>
  );
}

const LogoImage = styled(AppImageView)`
  width: ${({ theme }) => theme.hp(28)}px;
  height: ${({ theme }) => theme.hp(28)}px;
`;

const MessageBox = styled(Box)`
  margin: ${({ theme }) => theme.hp(7)}px;
  align-items: center;
  justify-content: center;
`;

const SuccessText = styled(AppTextView)`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.hp(3)}px;
`;

const BackButton = styled(AppButton)`
  margin-top: 30px;
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px;
`;
